
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore-university",
      function () {
        return require("private-next-pages/explore-university.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore-university"])
      });
    }
  